<script setup>
import { ref } from 'vue';
import { useForm } from '@inertiajs/vue3';
import ActionMessage from '@/Components/ActionMessage.vue';
import FormSection from '@/Components/FormSection.vue';
import InputError from '@/Components/InputError.vue';
import InputLabel from '@/Components/InputLabel.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import TextInput from '@/Components/TextInput.vue';
import { toast } from 'vue3-toastify';

const passwordInput = ref(null);
const currentPasswordInput = ref(null);
const currentPasswordInputVisible = ref(false);
const newPasswordInputVisible = ref(false);
const newPasswordCOnfirmInputVisible = ref(false);

const form = useForm({
    current_password: '',
    password: '',
    password_confirmation: '',
});

const updatePassword = () => {
    form.put(route('user-password.update'), {
        errorBag: 'updatePassword',
        preserveScroll: true,
        onSuccess: () => {
            form.reset();
            toast.success('Passeord updated');
        },
        onError: () => {
            if (form.errors.password) {
                form.reset('password', 'password_confirmation');
                passwordInput.value.focus();
            }

            if (form.errors.current_password) {
                form.reset('current_password');
                currentPasswordInput.value.focus();
            }
        },
    });
};
</script>

<template>
    <form @submit.prevent="updatePassword">
        <v-row>
            <v-col cols="12" sm="4">
                <div class="text-h6 pb-1">Update Password</div>
                <div class="text-body-2 text-secondary">Ensure your account is using a long, random password to stay secure.</div>
            </v-col>
            <v-col cols="12" sm="8">
                <v-card>
                    <v-card-text>
                        <div class="d-flex flex-column ga-2 pt-1">
                            <v-row>
                                <v-col cols="12" md="8" xl="7" class="d-flex flex-column ga-4">
                                    <div>
                                        <v-text-field-v1
                                            label="Current Password"
                                            v-model="form.current_password"
                                            ref="currentPasswordInput"
                                            :type="currentPasswordInputVisible ? 'text' : 'password'"
                                            placeholder="Enter your password"
                                            :error-messages="form.errors.current_password"
                                        >
                                            <template #append-inner >
                                                <span role="button" @click="currentPasswordInputVisible = !currentPasswordInputVisible">
                                                    <mdi-icon v-if="currentPasswordInputVisible">visibility</mdi-icon>
                                                    <mdi-icon v-else>visibility_off</mdi-icon>
                                                </span>
                                            </template>
                                        </v-text-field-v1>
                                    </div>
                                    <div>
                                        <v-text-field-v1
                                            label="New Password"
                                            v-model="form.password"
                                            ref="passwordInput"
                                            :type="newPasswordInputVisible ? 'text' : 'password'"
                                            placeholder="Enter your password"
                                            :error-messages="form.errors.password"
                                        >
                                            <template #append-inner >
                                                <span role="button" @click="newPasswordInputVisible = !newPasswordInputVisible">
                                                    <mdi-icon v-if="newPasswordInputVisible">visibility</mdi-icon>
                                                    <mdi-icon v-else>visibility_off</mdi-icon>
                                                </span>
                                            </template>
                                        </v-text-field-v1>
                                    </div>
                                    <div>
                                        <v-text-field-v1
                                            label="Confirm Password"
                                            v-model="form.password_confirmation"
                                            ref="passwordInput"
                                            :type="newPasswordCOnfirmInputVisible ? 'text' : 'password'"
                                            placeholder="Enter your password"
                                            :error-messages="form.errors.password_confirmation"
                                        >
                                            <template #append-inner >
                                                <span role="button" @click="newPasswordCOnfirmInputVisible = !newPasswordCOnfirmInputVisible">
                                                    <mdi-icon v-if="newPasswordCOnfirmInputVisible">visibility</mdi-icon>
                                                    <mdi-icon v-else>visibility_off</mdi-icon>
                                                </span>
                                            </template>
                                        </v-text-field-v1>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                        
                    </v-card-text>
                    <v-card-actions-default>
                        <div class="d-flex justify-space-between align-center flex-grow-1 ga-4">
                            <div>
                                <span class="text-success" v-if="form.recentlySuccessful">
                                    <span class="fa fa-check"></span> Saved
                                </span>
                            </div>
                            <v-btn-input-compact type="submit" color="primary" text="Save" :disabled="form.processing" :loading="form.processing">
                                <template #prepend>
                                    <mdi-icon>check</mdi-icon>
                                </template>
                            </v-btn-input-compact>
                        </div>
                    </v-card-actions-default>
                </v-card>
            </v-col>
        </v-row>
    </form>
    <!-- <FormSection @submitted="updatePassword">
        <template #title>
            Update Password
        </template>

        <template #description>
            Ensure your account is using a long, random password to stay secure.
        </template>

        <template #form>
            <div class="col-span-6 sm:col-span-4">
                <InputLabel for="current_password" value="Current Password" />
                <TextInput
                    id="current_password"
                    ref="currentPasswordInput"
                    v-model="form.current_password"
                    type="password"
                    class="mt-1 block w-full"
                    autocomplete="current-password"
                />
                <InputError :message="form.errors.current_password" class="mt-2" />
            </div>

            <div class="col-span-6 sm:col-span-4">
                <InputLabel for="password" value="New Password" />
                <TextInput
                    id="password"
                    ref="passwordInput"
                    v-model="form.password"
                    type="password"
                    class="mt-1 block w-full"
                    autocomplete="new-password"
                />
                <InputError :message="form.errors.password" class="mt-2" />
            </div>

            <div class="col-span-6 sm:col-span-4">
                <InputLabel for="password_confirmation" value="Confirm Password" />
                <TextInput
                    id="password_confirmation"
                    v-model="form.password_confirmation"
                    type="password"
                    class="mt-1 block w-full"
                    autocomplete="new-password"
                />
                <InputError :message="form.errors.password_confirmation" class="mt-2" />
            </div>
        </template>

        <template #actions>
            <ActionMessage :on="form.recentlySuccessful" class="me-3">
                Saved.
            </ActionMessage>

            <PrimaryButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Save
            </PrimaryButton>
        </template>
    </FormSection> -->
</template>
